"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ASCVDRiskScoreParams = exports.ASCVDRiskCoefficients = void 0;
var constants = require("../constants/constants");
var ASCVDRiskCoefficients = /** @class */ (function () {
    function ASCVDRiskCoefficients() {
    }
    return ASCVDRiskCoefficients;
}());
exports.ASCVDRiskCoefficients = ASCVDRiskCoefficients;
var ASCVDRiskScoreParams = /** @class */ (function () {
    function ASCVDRiskScoreParams() {
    }
    return ASCVDRiskScoreParams;
}());
exports.ASCVDRiskScoreParams = ASCVDRiskScoreParams;
var ASCVDRiskCalculator = /** @class */ (function () {
    function ASCVDRiskCalculator() {
    }
    ASCVDRiskCalculator.NNTForScore = function (riskScore) {
        var A = riskScore;
        var B = A * 0.9;
        var C = A - B;
        var D = C / 100;
        var E = Math.round(1 / D);
        return E;
    };
    ASCVDRiskCalculator.loadCoefficients = function () {
        var whiteFemale = new ASCVDRiskCoefficients();
        whiteFemale.logAge = -29.799;
        whiteFemale.logAgeSquared = 4.884;
        whiteFemale.logTotalCholesterol = 13.540;
        whiteFemale.logAgeLogTotalCholesterol = -3.114;
        whiteFemale.logHDL = -13.578;
        whiteFemale.logAgeLogHDL = 3.149;
        whiteFemale.logTreatedSystolicBP = 2.019;
        whiteFemale.logAgeLogTreatedSystolicBP = 0;
        whiteFemale.logUntreatedSystolicBP = 1.957;
        whiteFemale.logAgeLogUntreatedSystolicBP = 0;
        whiteFemale.smoker = 7.574;
        whiteFemale.logAgeSmoker = -1.665;
        whiteFemale.diabeters = 0.661;
        whiteFemale.meanSum = -29.18;
        whiteFemale.baselineSurvival = 0.9665;
        ASCVDRiskCalculator.whiteFemaleCoefficients = whiteFemale;
        var blackFemale = new ASCVDRiskCoefficients();
        blackFemale.logAge = 17.114;
        blackFemale.logAgeSquared = 0;
        blackFemale.logTotalCholesterol = 0.940;
        blackFemale.logAgeLogTotalCholesterol = 0;
        blackFemale.logHDL = -18.920;
        blackFemale.logAgeLogHDL = 4.475;
        blackFemale.logTreatedSystolicBP = 29.291;
        blackFemale.logAgeLogTreatedSystolicBP = -6.432;
        blackFemale.logUntreatedSystolicBP = 27.820;
        blackFemale.logAgeLogUntreatedSystolicBP = -6.087;
        blackFemale.smoker = 0.691;
        blackFemale.logAgeSmoker = 0;
        blackFemale.diabeters = 0.874;
        blackFemale.meanSum = 86.61;
        blackFemale.baselineSurvival = 0.9533;
        ASCVDRiskCalculator.blackFemaleCoefficients = blackFemale;
        var whiteMale = new ASCVDRiskCoefficients();
        whiteMale.logAge = 12.344;
        whiteMale.logAgeSquared = 0;
        whiteMale.logTotalCholesterol = 11.853;
        whiteMale.logAgeLogTotalCholesterol = -2.664;
        whiteMale.logHDL = -7.990;
        whiteMale.logAgeLogHDL = 1.769;
        whiteMale.logTreatedSystolicBP = 1.797;
        whiteMale.logAgeLogTreatedSystolicBP = 0;
        whiteMale.logUntreatedSystolicBP = 1.764;
        whiteMale.logAgeLogUntreatedSystolicBP = 0;
        whiteMale.smoker = 7.837;
        whiteMale.logAgeSmoker = -1.795;
        whiteMale.diabeters = 0.658;
        whiteMale.meanSum = 61.18;
        whiteMale.baselineSurvival = 0.9144;
        ASCVDRiskCalculator.whiteMaleCoefficients = whiteMale;
        var blackMale = new ASCVDRiskCoefficients();
        blackMale.logAge = 2.469;
        blackMale.logAgeSquared = 0;
        blackMale.logTotalCholesterol = 0.302;
        blackMale.logAgeLogTotalCholesterol = 0;
        blackMale.logHDL = -0.307;
        blackMale.logAgeLogHDL = 0;
        blackMale.logTreatedSystolicBP = 1.916;
        blackMale.logAgeLogTreatedSystolicBP = 0;
        blackMale.logUntreatedSystolicBP = 1.809;
        blackMale.logAgeLogUntreatedSystolicBP = 0;
        blackMale.smoker = 0.549;
        blackMale.logAgeSmoker = 0;
        blackMale.diabeters = 0.645;
        blackMale.meanSum = 19.54;
        blackMale.baselineSurvival = 0.8954;
        ASCVDRiskCalculator.blackMaleCoefficients = blackMale;
        ASCVDRiskCalculator.hasLoadedCoefficients = true;
    };
    ASCVDRiskCalculator.riskScore = function (riskScoreParams) {
        if (!ASCVDRiskCalculator.hasLoadedCoefficients) {
            ASCVDRiskCalculator.loadCoefficients();
        }
        var totalCholesterol = riskScoreParams.totalCholesterol;
        var hdlCholesterol = riskScoreParams.hdlCholesterol;
        var coefficients = null;
        if (riskScoreParams.race == constants.Race.Black) {
            if (riskScoreParams.gender == constants.Gender.Male) {
                coefficients = ASCVDRiskCalculator.blackMaleCoefficients;
            }
            else {
                coefficients = ASCVDRiskCalculator.blackFemaleCoefficients;
            }
        }
        else {
            if (riskScoreParams.gender == constants.Gender.Male) {
                coefficients = ASCVDRiskCalculator.whiteMaleCoefficients;
            }
            else {
                coefficients = ASCVDRiskCalculator.whiteFemaleCoefficients;
            }
        }
        var survival = coefficients.baselineSurvival;
        var meanSum = coefficients.meanSum;
        var logAge = Math.log(riskScoreParams.age);
        var logAgeSquared = logAge * logAge;
        var logTotalCholesterol = Math.log(totalCholesterol);
        var logAgeLogTotalCholesterol = logAge * logTotalCholesterol;
        var logHDL = Math.log(hdlCholesterol);
        var logAgeLogHDL = logAge * logHDL;
        var logTreatedSystolicBP = (riskScoreParams.treatedForHypertension ? 1 : 0) * Math.log(riskScoreParams.systolicBloodPressure);
        var logAgeLogTreatedSystolicBP = logAge * logTreatedSystolicBP;
        var logUntreatedSystolicBP = ((!riskScoreParams.treatedForHypertension) ? 1 : 0) * Math.log(riskScoreParams.systolicBloodPressure);
        var logAgeLogUntreatedSystolicBP = logAge * logUntreatedSystolicBP;
        var logAgeSmoker = (riskScoreParams.isSmoker ? 1 : 0) * logAge;
        var values = [(logAge), (logAgeSquared), (logTotalCholesterol),
            (logAgeLogTotalCholesterol), (logHDL), (logAgeLogHDL), (logTreatedSystolicBP),
            (logAgeLogTreatedSystolicBP), (logUntreatedSystolicBP), (logAgeLogUntreatedSystolicBP),
            (riskScoreParams.isSmoker ? 1 : 0), (logAgeSmoker), (riskScoreParams.hasDiabetes ? 1 : 0)];
        var c = coefficients;
        var coefficientsArray = [(c.logAge), (c.logAgeSquared), (c.logTotalCholesterol),
            (c.logAgeLogTotalCholesterol), (c.logHDL), (c.logAgeLogHDL),
            (c.logTreatedSystolicBP), (c.logAgeLogTreatedSystolicBP),
            (c.logUntreatedSystolicBP), (c.logAgeLogUntreatedSystolicBP), (c.smoker), (c.logAgeSmoker), (c.diabeters)];
        var sum = 0;
        for (var i = 0; i < values.length; i++) {
            var value = values[i];
            var coefficent = coefficientsArray[i];
            sum += value * coefficent;
        }
        var riskScore = 1 - Math.pow(survival, Math.exp(sum - meanSum));
        riskScore *= 100;
        return riskScore;
    };
    ASCVDRiskCalculator.hasLoadedCoefficients = false;
    return ASCVDRiskCalculator;
}());
exports.default = ASCVDRiskCalculator;
//# sourceMappingURL=ASCVDRiskCalculator.js.map


/** WEBPACK FOOTER **
 ** ./src/models/ASCVDRiskCalculator.js
 **/